/**
 * API Response Transformers
 *
 * Bu dosya API yanıtlarını işlemek için yardımcı fonksiyonlar içerir.
 * Kullanım: JSON parse, tarih dönüşümleri, NaN temizleme vb.
 */
import { yieldToMain } from "@/utils/yieldToMain";
/**
 * ISO formatındaki tarih stringlerini JavaScript Date nesnesine dönüştürür
 */
export function parseISODates(obj) {
    if (!obj)
        return obj;
    // ISO tarih formatı string ise Date'e çevir
    if (typeof obj === "string" &&
        obj.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
        return new Date(obj);
    }
    // Array ise her elemanı recursive işle
    if (Array.isArray(obj)) {
        return obj.map((item) => parseISODates(item));
    }
    // Object ise her property'yi recursive işle
    if (typeof obj === "object") {
        const result = {};
        const record = obj;
        for (const key in record) {
            // _saniye ile biten özellikler için dönüşüm yapmadan doğrudan kopyala
            if (key.endsWith("_saniye")) {
                result[key] = record[key];
            }
            else {
                result[key] = parseISODates(record[key]);
            }
        }
        return result;
    }
    return obj;
}
const PARSE_ISO_DATES_CHUNK = 80;
/**
 * Büyük API yanıtlarında parseISODates'i ana iş parçacığında parçalar.
 */
export async function parseISODatesAsync(obj, chunkSize = PARSE_ISO_DATES_CHUNK) {
    if (!obj)
        return obj;
    if (typeof obj === "string" &&
        obj.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
        return new Date(obj);
    }
    if (Array.isArray(obj)) {
        if (obj.length <= chunkSize) {
            return obj.map((item) => parseISODates(item));
        }
        const result = [];
        for (let i = 0; i < obj.length; i += chunkSize) {
            const end = Math.min(i + chunkSize, obj.length);
            for (let j = i; j < end; j++) {
                result.push(parseISODates(obj[j]));
            }
            if (end < obj.length) {
                await yieldToMain();
            }
        }
        return result;
    }
    if (typeof obj === "object") {
        return parseISODates(obj);
    }
    return obj;
}
/**
 * JSON string içindeki NaN değerlerini null ile değiştirir
 */
export function cleanNaNValues(jsonString) {
    return jsonString.replace(/:\s*NaN\s*([,}])/g, ": null$1");
}
/**
 * API response'unu parse eder ve işler
 * - String ise JSON parse et
 * - NaN değerlerini temizle
 * - ISO tarihlerini Date'e çevir
 */
export function parseApiResponse(response) {
    let data = response.data;
    // Eğer data string ise parse et
    if (typeof data === "string") {
        try {
            // NaN değerlerini temizle
            const cleaned = cleanNaNValues(data);
            data = JSON.parse(cleaned);
        }
        catch (error) {
            console.error("API response parse hatası:", error);
            const message = error instanceof Error ? error.message : String(error);
            throw new Error("API yanıtı parse edilemedi: " + message);
        }
    }
    // ISO tarihlerini dönüştür
    return parseISODates(data);
}
